module.exports = __webpack_public_path__ + "img/CrimsonText-Regular.88bec7ad.svg";